import React, { useState } from "react";
import { Container } from "./styles";
import Modal from "react-modal";
import classNames from "classnames";
import useClickedOutside from "../../../hooks/useClickedOutside";
import { OUTLINE_FRAMWORKS, OUTLINE_TYPES } from "../../../../../src/shared/storyEngineConstants";
import { useProjectStore } from "../../../stores/projectStore";
import TextArea from "react-textarea-autosize";
import { useStructuredOutlineStore } from "../StructuredOutline/StructuredOutlineStore";
import { AppEventPublisher, StoryBibleAction, StoryBibleType } from "../../../AppEventPublisher";

Modal.setAppElement("#root");

const OutlinePicker = ({ close, commitType, currentType }) => {
  const project = useProjectStore((state) => state.project);
  const ref = useClickedOutside(close);
  const customOutlineInstructions = useStructuredOutlineStore((state) => state.outline.content.instructions);
  const setCustomOutlineInstructions = useStructuredOutlineStore((state) => state.setCustomOutlineInstructions);

  const customStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(55, 55, 55, 0.7)",
      zIndex: "100000001",
    },
    content: {
      top: "5%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      zIndex: "20000",
      width: "750px",
      transform: "translate(-50%, 0)",
      borderRadius: "15px",
      border: "0px",
      padding: "0px",
      background: "#f5f2e4",
      boxShadow: "var(--default-drop-shadow)",
      height: "600px",
      maxHeight: "90%",
      overflowX: "hidden",
    },
  };

  const [type, setType] = useState(currentType || OUTLINE_TYPES[0]);

  const filteredOutlineTypes = project.useStructuredOutline ? OUTLINE_TYPES : OUTLINE_TYPES.filter((t) => t.value !== OUTLINE_FRAMWORKS.CUSTOM_OUTLINE);
  return (
    <Modal
      isOpen={true}
      contentRef={(node) => (ref.current = node)}
      style={customStyles}
    >
      <Container className="picker">
        <div className="templates">
          <h2
            role="heading"
            aria-label="Outline Type Header"
            tabIndex={0}
          >
            Outline Type
          </h2>

          <ul>
            {filteredOutlineTypes.map((t) => {
              return (
                <li
                  tabIndex={0}
                  key={t.value}
                  className={classNames({ active: type.value === t.value })}
                  onClick={(e) => {
                    setType(t);
                  }}
                  aria-label={`${t.value} outline type, press Enter to select.`}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      setType(t);
                    }
                  }}
                >
                  {t.label}
                </li>
              );
            })}
          </ul>
        </div>
        <div className="template">
          <h3
            tabIndex={0}
            aria-label="Heading - Outline Description"
          >
            GREAT FOR:
          </h3>
          <p tabIndex={0}>{type.great}</p>

          {type.value !== OUTLINE_FRAMWORKS.CUSTOM_OUTLINE && (
            <>
              <h3 tabIndex={0}>EXAMPLES:</h3>
              <div className="examples">
                {type.examples?.map((example, i) => (
                  <p
                    tabIndex={0}
                    key={`example_${i}`}
                  >
                    {example}{" "}
                  </p>
                ))}
              </div>
            </>
          )}

          {type.value === OUTLINE_FRAMWORKS.CUSTOM_OUTLINE && (
            <>
              <h3 tabIndex={0}>INSTRUCTIONS:</h3>

              <div className="instructions">
                <TextArea
                  autoFocus
                  placeholder="Type your instructions here..."
                  value={customOutlineInstructions}
                  onChange={(e) => {
                    const wasEmpty = !customOutlineInstructions;
                    setCustomOutlineInstructions(e.target.value);
                    if (wasEmpty) {
                      AppEventPublisher.storyBible.action(StoryBibleType.outline, StoryBibleAction.SetCustomOutlineInstructions);
                    }
                  }}
                />
              </div>
            </>
          )}

          <div className="cta">
            <button
              onClick={(e) => {
                commitType(type);
                AppEventPublisher.storyBible.outline.selectOutlineType(type.value);
                close();
              }}
            >
              Use {type.label}
            </button>
          </div>
        </div>
      </Container>
    </Modal>
  );
};

export default OutlinePicker;
